import { render, staticRenderFns } from "./navbarPrincipal.vue?vue&type=template&id=0a124b56&scoped=true&"
import script from "./navbarPrincipal.vue?vue&type=script&lang=js&"
export * from "./navbarPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./navbarPrincipal.vue?vue&type=style&index=0&id=0a124b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a124b56",
  null
  
)

export default component.exports